module.exports = __webpack_public_path__ + "bubble.79d4675f.mp3";